import { defineComponent as _defineComponent } from 'vue'
import { inject, ref, Ref } from 'vue';

import {
  HeadingDisplay,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { DetailsSidebar } from '@/modules/transaction/components/DetailsSidebar';

import {
  IWithdrawReview,
  IDetails
} from '@/modules/transaction/services/product-withdraw';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewStep',
  setup(__props) {

const withdrawReview = inject('withdrawReview') as Ref<IWithdrawReview>;

const isFetchingWithdraw = inject('isFetchingWithdraw') as Ref<boolean>;

const fetchWithdraw = inject('fetchWithdraw', () => ({}));

const isLoading = ref(false);
const isDetailsOpen = ref(false);
const sidebarDetails = ref<IDetails>({
  title: '',
  description: '',
  button: null
});

function openDetails(details: IDetails | null) {
  if (!details) return;

  sidebarDetails.value = details;
  isDetailsOpen.value = true;
}

function handleClick() {
  fetchWithdraw();
}

return { __sfc: true,withdrawReview, isFetchingWithdraw, fetchWithdraw, isLoading, isDetailsOpen, sidebarDetails, openDetails, handleClick, HeadingDisplay, ContentDisplay, Heading, ListDisplay, ButtonContainer, ButtonPrimary, DetailsSidebar }
}

})